<i18n src="@/locales/modules/TitleTranslate.json"></i18n>

<template>
	<div class="title-config">
		<div>
			<!-- Title -->
			<label for class="vs-input--label">{{ $t("TitleName") }}<span class="text-danger">*</span>:</label>

			<CbsEmployeeTitles
				class="w-full"
				:name="`${formName}--employee-titles`"
				v-validate="'required'"
				v-model="title"
				:type="1"
				:close-on-select="false"
				:for="'people'"
				:placeholder="`${$t('Actions.Choose')} ${$t('TitleName').toLowerCase()}`"
				:data-vv-as="$t('TitleName')"
			/>
			<span class="text-danger text-sm" v-show="errors.has(`${formName}--employee-titles`)">{{ errors.first(`${formName}--employee-titles`) }}</span>
		</div>
	</div>
</template>

<script>
import * as _ from "lodash";
import vSelect from "vue-select";

import CbsEditor from "@/components/cbs-editor/CbsEditor";
import CbsEmployeeTitles from "@/components/cbs-employee-titles/CbsEmployeeTitles";

const isValidTitleData = title => _.has(title, "id") && _.has(title, "name");

export default {
	name: "TitleConfig",
	inject: ["parentValidator"],
	props: {
		value: {
			type: Object,
			required: true,
			validator: prop => isValidTitleData(prop)
		},
		formName: {
			type: String,
			default: "title-config-for-role"
		}
	},
	emits: {
		onClickDelete: {}
	},
	components: {
		vSelect,
		CbsEditor,
		CbsEmployeeTitles
	},
	data() {
		return {
			title: null
		};
	},
	computed: {
		localTitle: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		}
	},
	watch: {
		title(val) {
			Object.assign(this.localTitle, val);
		}
	},
	created() {
		this.title = this.value.id ? { id: this.value.id, name: this.value.name } : null;
		if (this.parentValidator) {
			this.$validator = this.parentValidator;
		}
	}
};
</script>

<style lang="scss">
.title-config {
	padding: 25px;
	border-radius: 4px;
	background: #f8f8f8;
}
</style>
